import { render } from "./YamsTemplate.vue?vue&type=template&id=57e61272&scoped=true&ts=true"
import script from "./YamsTemplate.vue?vue&type=script&lang=ts"
export * from "./YamsTemplate.vue?vue&type=script&lang=ts"

import "./YamsTemplate.vue?vue&type=style&index=0&id=57e61272&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e61272"]])

export default __exports__